import styled from "styled-components";
import { IconButton, StyledButtonGroup } from "@components/button";

export const IconButtonStyled = styled(IconButton) `
    margin-top: 3px;
    margin-right: 3px;
`;

export const UserIconSelectWrapper = styled.div `
    position: relative;
    //DEV-38812
    ${StyledButtonGroup} & {
        margin-right: -10px;
    }

`;

export const MessageCountWrapper = styled.div `
    min-width: 16px;
    min-height: 16px;
    background-color: ${props => props.theme.C_ACT_der};
    top: 0px;
    right: 0px;
    z-index: 1;
    
    position: absolute;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MessageCount = styled.div `
    color: ${props => props.theme.C_TEXT_dialogue};
    font-size: 9px;
`;